
import { validationPlugin } from "./LinkEmbedWithInput"
import { highlightPlugin } from "./ListingModule"
import { uniqueStringValidationPlugin } from "./TextInput"
import { cata_uniqueStringValidationPlugin } from "./cata_uniqueStringValidation"
import { useMarkAsWinnerPlugin } from "./gsl_useMarkAsWinnerPlugin"
import { useGSLHeaderPopupPlugin } from "./gsl_headerPopupPlugin"
import {OAuthLoginButton} from "./mad_OAuthLoginButton"
import { mad_VolunteerDashboardTab } from "./mad_VolunteerDashboardTab"
import {overwriteRTEDefaultInternalEmbedConfig} from './overwriteRTEDefaultInternalEmbedConfig'
import { getTenant } from "@/TENANT_CONFIGS"
import { mad_useChildDataOptions } from "./mad_useChildDataOptions"



export const pluginConfigs = {
    ved: {
        LinkEmbedWithInput: {
            validationPlugin
        }
    },
    nkms: {
        LinkEmbedWithInput: {
            validationPlugin
        },
    },
    gsl: {
        ListingModule: {
            highlightPlugin
        },
        contentTypesManager_contentTypeLanding_inPublish: {
            rowActionPlugin: useMarkAsWinnerPlugin
        },
        HeaderUI: {
            headerPopupPlugin: useGSLHeaderPopupPlugin
        },
        annotationExplorer_dataViz: {
            parent: "subThemes",
            child: "tags"
        }
    },
    mad: {
        EmailPassLogin: {
            OAuthLoginButton
        },
        MyDashboardTabs: {
            mad_VolunteerDashboardTab
        }
    },
    gelabs: {
        overwriteRTEDefaultInternalEmbedConfig
    },
    /**
     * for tpl blocks specific plugins, we can simply 
     * dump them here, and in the blockConfig.props,
     * we can have a prop called for example:
     * {
     *   plugin: { valiadation: <nameofpluginfunction> }
     * }
     * and that should do the job
     */
    tplBlockPlugins: {
        validationPlugin,
        uniqueStringValidationPlugin, //gelabs
        cata_uniqueStringValidationPlugin,
        mad_useChildDataOptions
    }
}

export const getPluginConfigsForTenant = () => {
    return pluginConfigs[getTenant()];
}
